import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import 'aws-amplify/auth/enable-oauth-listener';

import App from './App';
import { amplifyConfig } from './lib/amplify-config';
import './styles/global.css';

Amplify.configure(amplifyConfig);

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to locate #root element');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
